import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CompanyEntity } from '@nk/data-entities-lib';
import { PrettyCompanyNamePipe } from '../../pipes/pretty-company-name.pipe';
import { CompanyOrgNrComponent } from '../company-org-nr/company-org-nr.component';

@Component({
  selector: 'nk-company-title',
  imports: [PrettyCompanyNamePipe, CompanyOrgNrComponent],
  templateUrl: './company-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyTitleComponent {
  public company = input.required<CompanyEntity>();
  public showFlag = input(true);
  public disableClipboardCopy = input(true);
  public showOrgNr = input(true);
}
